var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-butList"},[_vm._l((_vm.list),function(item,index){return [_c('a',{key:index,staticClass:"control-item",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.doLightCmd(item)}}},[_c('img',{attrs:{"src":item.img}}),_vm._v(" "+_vm._s(item.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }